<script setup lang="ts">
import MovieCsfdItemContent from "./MovieCsfdItemContent.vue";
import MovieCsfdItem from "./MovieCsfdItem.vue";

type TPerson = {
  Name: string;
  Url: string;
};

type TProps = {
  people: Array<TPerson>;
  label: string;
};

const props = defineProps<TProps>();

const hasName = (person: TPerson) => {
  return person.Name.trim().length > 0;
};

const filteredPeople = computed(() => {
  return props.people.filter(hasName);
});
</script>

<template>
  <template v-if="filteredPeople.length > 0">
    <MovieCsfdItem :label="label">
      <template v-for="(value, index) in filteredPeople" :key="index">
        <MovieCsfdItemContent :name="value?.Name" :url="value?.Url" />
      </template>
    </MovieCsfdItem>
  </template>
</template>
